<script lang="ts">
  import { getContextScope } from '$lib/js/helpers/i18n'
  import { setTagName, getTagColor, getTagIcon } from '$lib/js/helpers'
  import { page } from '$app/state'

  interface Props {
    tags?: string[];
  }

  let { tags = [] }: Props = $props();
  const scope = getContextScope()
  let cat_url = page.params.cat_url
  let link = $state('')

  if(cat_url) {
    cat_url = cat_url.split('/')[0]
    link = cat_url
  } else if (page.data.category) {
    link = page.data.category.url_path.split('/')[1]
  }
</script>

<div class="tags">
  {#if tags && tags?.length > 0}
    {#each tags.slice(0, 2) as tag}
      <a href={`/${scope}/t/${tag}/${link}`} class="tag {getTagIcon(tag)}" style="background-color: {getTagColor(tag)}">
        {setTagName(tag)} <span class="icon icon-{getTagIcon(tag)}"></span>
      </a>
    {/each}
  {/if}
</div>

<style lang="scss">
  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;

    .tag {
      display: flex;
      align-items: center;
      text-align: center;
      text-transform: uppercase;
      padding: 2px 8px;
      color: white;
      font-size: 12px;
      font-weight: 700;

      span {
        font-weight: 400;
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
</style>